
 
import { React, useEffect, useState, Fragment, useCallback, useRef, useMemo } from "react";

import cogoToast from "cogo-toast";
import { SUCCESS_RESULT, TEMPLATES_URL, ENDPOINTS, LOCAL_PARAMS } from "../../Constants";
import { getTemplateByName, genericPost, genericGet } from "../../services/Api";
import { EbmsLoading, localizeData, getLocalizeData, resetLocalizeData, isObjectEmpty, log } from "../../services/Utils";

import { Spinner } from "reactstrap";
import { useHistory, Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Table, Button } from "reactstrap";
// import * as d3 from "d3";
import "./styles.css";
import * as FaIcons from 'react-icons/fa';
import * as SurveyCore from "survey-core";
import { Survey } from 'survey-react-ui';
// import "survey-core/defaultV2.css";
import "survey-creator-core/survey-creator-core.min.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { FileSaver, saveAs } from 'file-saver';
import * as Alerts from '../customs/Alerts'
import { PERMS } from "../config/perms";
 
SurveyCore.StylesManager.applyTheme("darkblue");

const TemplateConfigurations = (props) => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    // const [templates, setAllTemplates] = useState([]);

let templates=[];
    const [selectedTemplate, setSelectedTemplate] = useState({});
    const [currentLastSelection, setCurrentLastSelection] = useState({});
    const [superSets, setSuperSets] = useState({
        "country": "",
        "zone": "",
        "region": "zone",
        "district": "region",
        "village": "district",
        "camp": "village"
    });

    const [model, setModel] = useState(new SurveyCore.Model(selectedTemplate));

    useEffect(() => {
        // loadSelectedTemplates(0);
setCurrentLastSelection({
    "2": "2",
  
   
    "saad": {
        "five_17": {
            "male": 0,
            "female": 0
        },
        "under_5": {
            "male": 0,
            "female": 0
        },
        "sixty_80": {
            "male": 0,
            "female": 0
        },
        "eighteen_59": {
            "male": 0,
            "female": 0
        },
        "eighty_above": {
            "male": 0,
            "female": 0
        }
    },
    "saad-total": {
        "male": 0,
        "female": 0
    },
    "pwdl": {
        "male": "0",
        "female": "0"
    },
    "hh_women_headed": "1",
    "hh_child_headed": "1",
    "chronic_illness": "1",
    "unreliable_income": "1",
    "lactating_mother": "1",
    "less_food_reserve": "1",
    "elderly_person": "1",
    "employed": "1",
    "supported": "1",
    "assistance": "1",
    "total_asset": "1",
    "access_health": "1",
    "access_water": "1",
    "sanitation": "1",
    "access_electricity": "1",
    "access_meal": "1",
    "working": "1",
    "loans": "1",
    "sell_assets": "1",
  
     
    "hh_profile": 59.99,
    "hh_econ": 13.32,
    "hh_services_access": 13.32,
    "hh_coping": 13.32,
    "score": 99.95,
    "can_proceed": true
})
        // setTimeout(() => {
            loadTemplates();
            // log("Template Data", templates);
        // }, 3000);

        // setTimeout(() => {
        //     setModel(loadSelectedTemplates(0));
        // }, 3000);

        return () => { };
    }, []);

    // var baseFilterModel = new SurveyCore.Model(selectedTemplate);
    //configs
    const containerStyle = useMemo(() => ({ width: '100%', height: '100%', backgroundColor: "#ffffff" }), []);
    //incoming data $sim = similar_text(strtoupper('Moge A'), strtoupper('Mooge B'), $perc);
    let data = props.location.state;
    //functions
    const submitChanges = (index) => {
        //check the changes 
     
        log("DATA: ", model.data);
        let rawData = model.data;
        let rawDataForSelection=rawData;
     
        let dataToSend = [];
        if (!isObjectEmpty(rawData)) {
            for (const key in rawData) {
                let dataItem = {};
                if(rawData[key]=="other"){
                if (rawData[key + "-Comment"] != undefined) {
                    //remove it from selection
                    let ss = superSets[key];
                    let ssData = "";
                    if (ss !== "") {
                        ssData = model.getQuestionByName(ss).value;
                        if (ssData === null || ssData === "" || ssData === "other" || ssData == undefined) {
                            //quit
                            cogoToast.error("You must select the " + model.getQuestionByName(ss).title + " which already exist in the system.", {});
                            return;
                        }
                    }
                    // log("QSV: ",ssData);
                    let result = rawData[key + "-Comment"].split(/\r?\n/);
                    let entryResults = [];
                    if (result.length > 0) {
                        for (let r = 0; r < result.length; r++) {
                            let otherItem = {};
                            let action = "";
                            let text = result[r];
                            if (result[r].includes("|")) {
                                let rsdata = result[r].split("|")
                                text = rsdata[0];
                                if (rsdata[1] !== 'A') {
                                    cogoToast.error("Invalid others configuration. Symbol | should have the appropriate action eg. A=Accept", {});
                                    return;
                                }
                                action = rsdata[1];
                            }
                            otherItem["text"] = text;
                            otherItem["action"] = action;
                            entryResults.push(otherItem);
                        }
                    }
                    // dataItem["ss"] = 
                    dataItem["tid"] = "0a1a79ec-94bc-11ec-b744-0a9ea65235cc";
                    dataItem["qss_value"] = ssData;
                    dataItem["qss_name"] = ss;
                    dataItem["qsn_value"] = key;
                    dataItem["others"] = entryResults
                    dataToSend.push(dataItem);
                }else{
                    //just a normal selection
                }}
            };
            // log("ITEM: ", dataToSend);
            //send to server
            setIsLoading(true);
            genericPost(ENDPOINTS.AMEND_TEMPLATE, dataToSend)
                .then((res) => {
                    setIsLoading(false);
                    if (res.status == 200) {
                        if (res.data.status == SUCCESS_RESULT) {
                            if (!isObjectEmpty(rawDataForSelection)) {
                                for (const key in rawDataForSelection) {
                                    if (rawDataForSelection[key + "-Comment"] != undefined) {
                                        //remove it from selection
                                        delete rawDataForSelection[key + "-Comment"];
                                        delete rawDataForSelection[key];
                                    }

                                }
                                setCurrentLastSelection({});
                                setCurrentLastSelection(rawDataForSelection);
                                log("SELECTED: ",rawDataForSelection);
                                model.data=rawDataForSelection;
                              
                                model.showCompleteButton = false;

                            }
                           
                            cogoToast.success(res.data.message, {});
                            let templateData = res.data.data;
                            setModel(loadSelectedTemplates(templateData));
                            setTimeout(() => {

                                model.showCompleteButton = false;
                                model.showNavigationButtons = false;


                            }, 2000);

                            // setSelectedTemplate(templateData)
                        } else {
                            cogoToast.error(res.data.message, {});
                        }
                    }
                })
                .catch((err) => {
                    setIsLoading(false);
                    console.log(err);
                });
        } else {
            cogoToast.error("Opps, you dont have any new changes to save.", {});
        }
    };
    const defaultColDef = useMemo(() => {
        return {
            editable: false,
            sortable: true,
            flex: 1,
            minWidth: 100,
            filter: true,
            resizable: true,
        };
    }, []);
    const loadSelectedTemplates = (selectTemplat) => {
           let innerModel = new SurveyCore.Model(selectTemplat);
           innerModel.showCompleteButton = false;

            let allQuestions = innerModel.getAllQuestions();

            if (allQuestions.length > 0) {
                for (let a = 0; a < allQuestions.length; a++) {
                    if (allQuestions[a]['choices'] != undefined) {
                        let nameText = "";
                        if (allQuestions[a]['text'] != undefined)
                            nameText = allQuestions[a]['text'];
                        if (allQuestions[a]['title'] != undefined)
                            nameText = allQuestions[a]['title'];
                        innerModel.findQuestionByName(allQuestions[a]['name']).showOtherItem = true;
                        innerModel.findQuestionByName(allQuestions[a]['name']).otherText = "Add new " + nameText;
                        // log("UPDATED: " + nameText);
                    }
                }
            }
            innerModel.widthMode = "responsive";
            innerModel.showNavigationButtons = false;
            innerModel.ignoreValidation = true;

            
        return innerModel;
    }
    const _loadSelectedTemplates = (index) => {
        let innerModel = new SurveyCore.Model({});
        if (templates.length > 0) {
            let template = templates[index];
            setSelectedTemplate(template);
            // setModel(new SurveyCore.Model(selectedTemplate));
            // setTimeout(() => {

            // }, 1000);

            innerModel = new SurveyCore.Model(selectedTemplate);
            let allQuestions = innerModel.getAllQuestions();

            if (allQuestions.length > 0) {
                for (let a = 0; a < allQuestions.length; a++) {
                    if (allQuestions[a]['choices'] != undefined) {
                        let nameText = "";
                        if (allQuestions[a]['text'] != undefined)
                            nameText = allQuestions[a]['text'];
                        if (allQuestions[a]['title'] != undefined)
                            nameText = allQuestions[a]['title'];
                        // allQuestions[a]['showOtherItem'] = true;
                        // allQuestions[a]['otherText'] = "Add new " + nameText;
                        innerModel.findQuestionByName(allQuestions[a]['name']).showOtherItem = true;
                        innerModel.findQuestionByName(allQuestions[a]['name']).otherText = "Add new " + nameText;
                        // log("UPDATED: " + nameText);
                    }
                }
            }

            // setSelectedTemplate(template);

        } else {
            // log("Template: ", "No template");
        }
        // var baseFilterModelFiltered = new SurveyCore.Model(selectedTemplate);
        return innerModel;
    }
    const loadTemplates = () => {
        setIsLoading(true);
        genericGet(ENDPOINTS.LOCATION_TEMPLATE)
            .then((res) => {
                setIsLoading(false);
                if (res.status == 200) {
                    if (res.data.status == SUCCESS_RESULT) {
                        cogoToast.success(res.data.message, {});
                        let templateData = res.data.data;
                        // log("INC TEMP: ",templateData[0]["template"]);
                      
                    
                        setModel(loadSelectedTemplates(templateData));
                      
                     
                    } else {
                        cogoToast.error(res.data.message, {});
                    }
                }
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
        // setIsLoading(true);
        // genericGet(ENDPOINTS.LOAD_PERMISSIONS, {})
        //     .then((res) => {
        //         setIsLoading(false);
        //         if (res.status == 200) {
        //             if (res.data.status == SUCCESS_RESULT) {
        //                 let responseData = res.data.data;
        //                 setAllTemplates(responseData);
        //             } else {
        //                 cogoToast.error(res.data.message, {});
        //             }
        //         }
        //     })
        //     .catch((err) => {
        //         setIsLoading(false);
        //         console.log(err);
        //     });


        model.showCompleteButton = false;
    };

    return (
        <div>
            <Breadcrumb style={{ backgroundColor: '#ffffff' }} className="ms-1 p-2">
                <BreadcrumbItem>
                    <Link to="/ebms"> EBMS </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active >
                    <Link to="/ebms/template-configurations"> TEMPLATES CONFIGURATIONS </Link>
                </BreadcrumbItem>
            </Breadcrumb>
            <div className="ms-1 p-2" style={containerStyle}>
                {/* <Survey style="backgroundColor:#ffffff" model={baseFilterModel} data={currentLastSelection} /> */}
                <div style={containerStyle} class="pull-left">
                <center><EbmsLoading data={isLoading} /></center>
                    <div class="pull-rightx">
                        {/* <div style={{ border: "5px" }} > */}
                            <br /><br />
                            <button style={{ color: "#ffffff" }} onClick={submitChanges} class="btn btn-primary btn-l">
                                {/* <span class=""  role="button" aria-expanded="false"> */}
                                    <center>
                                        {/* <span style={{ color: "#ffffff" }}> */}
                                        <i class="fa fa-save"></i>&nbsp;Save Changes
                                        {/* </span> */}
                                        </center>
                                    {/* <span class="badge badge-sm bg-green-lt text-uppercase ms-auto">New</span> */}
                                {/* </span> */}

                            </button>
                        {/* </div> */}
                    </div> 
                    <Survey style="backgroundColor:#ffffff" model={model} data={currentLastSelection} />

                </div>
            </div>
        </div>
    );
}

export default TemplateConfigurations;
